module.exports = __webpack_public_path__ + "images/travelhomebd3f8b59cef3d6ef7e9763439f23b209.png";